import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import ptBRCommon from './locales/pt-BR/common.json';

export const commonResources = {
  en: {
    common: enCommon,
  },
  es: {
    common: esCommon,
  },
  'pt-BR': {
    common: ptBRCommon,
  },
};

export const supportedLanguages = ['en', 'es', 'pt-BR'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  'pt-BR': 'Português',
};
